import {
  GET_DASHBOARD_MESSAGE,
  CONFIGURATION_ERROR,
  UPDATE_DASHBOARD_MESSAGE,
} from 'src/actions/types'

const initialState = {
  dashboardMessage: null,
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_DASHBOARD_MESSAGE:
      return {
        ...state,
        dashboardMessage: payload,
        loading: false,
      }

    case UPDATE_DASHBOARD_MESSAGE:
      return {
        ...state,
        dashboardMessage: payload,
        loading: false,
      }
    case CONFIGURATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }

    default:
      return state
  }
}
